import {
  ReactElement,
  useCallback,
  useState,
} from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { NcInput, NcInputPropsT } from '../NcInput';
import { NcVisibilityToggle } from '../NcVisibilityToggle';

import '@consumer-bootstrap/netcredit.scss';

export type NcPasswordPropsT = Omit<NcInputPropsT, 'type'>;

export const NcPassword = ({
  className,
  ...props
}: NcPasswordPropsT): ReactElement => {
  const [isMasked, setIsMasked] = useState<boolean>(true);

  const handleToggleMask = useCallback((): void => {
    setIsMasked((previousMaskState) => !previousMaskState);
  }, []);

  return (
    <NcInput
      {...props}
      className={mergeClassNameStrings('nc-password', className)}
      suffix={(
        <NcVisibilityToggle
          hideLabel="Hide Password"
          isMasked={isMasked}
          onToggle={handleToggleMask}
          showLabel="Show Password"
        />
      )}
      type={isMasked ? 'password' : 'text'}
    />
  );
};
